<nav class="navbar navbar-expand-lg p-0">
    <ul class="navbar-nav">
        <li class="nav-item nav-icon-hover-bg rounded-circle">
            <a class="nav-link sidebartoggler" id="headerCollapse" href="javascript:void(0)">
                <iconify-icon icon="solar:list-bold-duotone" class="fs-7"></iconify-icon>
            </a>
        </li>
    </ul>

    <div class="d-block d-lg-none py-3">
        <img src="@@webRoot/assets/images/logos/logo-light.svg" class="dark-logo" alt="Logo-Dark" />
        <img src="@@webRoot/assets/images/logos/logo-dark.svg" class="light-logo" alt="Logo-light" />
    </div>


    <a class="navbar-toggler p-0 border-0" href="javascript:void(0)" data-bs-toggle="collapse"
       data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="p-2">
          <i class="ti ti-dots fs-7"></i>
        </span>
    </a>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
        <div class="d-flex align-items-center justify-content-between">
            <a href="javascript:void(0)" class="nav-link d-flex d-lg-none align-items-center justify-content-center"
               type="button" data-bs-toggle="offcanvas" data-bs-target="#mobilenavbar"
               aria-controls="offcanvasWithBothOptions">
                <div class="nav-icon-hover-bg rounded-circle ">
                    <i class="ti ti-align-justified fs-7"></i>
                </div>
            </a>
            <ul class="navbar-nav flex-row ms-auto align-items-center justify-content-center">
                <!--
                <li class="nav-item nav-icon-hover-bg rounded-circle">
                    <a class="nav-link moon dark-layout" href="javascript:void(0)">
                        <iconify-icon icon="solar:moon-line-duotone" class="moon fs-6"></iconify-icon>
                    </a>
                    <a class="nav-link sun light-layout" href="javascript:void(0)">
                        <iconify-icon icon="solar:sun-2-line-duotone" class="sun fs-6"></iconify-icon>
                    </a>
                </li>
                -->

                <!-- start: Message dropdown
                <li class="nav-item dropdown nav-icon-hover-bg rounded-circle">
                    <a class="nav-link position-relative" href="javascript:void(0)" id="drop3"
                       aria-expanded="false">
                        <iconify-icon icon="solar:chat-dots-line-duotone" class="fs-6"></iconify-icon>
                        <div class="pulse">
                            <span class="heartbit border-warning"></span>
                            <span class="point text-bg-warning"></span>
                        </div>
                    </a>
                    <div class="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up" aria-labelledby="drop3">
                        @@include("./header-components/dd-messages.html")
                    </div>
                </li>
                end: Message dropdown -->

                <!-- ------------------------------- -->
                <!-- start profile Dropdown -->
                <!-- ------------------------------- -->
                <li class="nav-item dropdown">
                    <a class="nav-link position-relative ms-6" href="javascript:void(0)" id="drop1"
                       aria-expanded="false">
                        <div class="d-flex align-items-center flex-shrink-0">
                            <div class="user-profile me-sm-3 me-2" style="margin-top: 32px">
                                <iconify-icon icon="solar:user-circle-bold-duotone" class="fs-11 text-primary"></iconify-icon>
                            </div>
                            <span class="d-sm-none d-block"><iconify-icon
                                    icon="solar:alt-arrow-down-line-duotone"></iconify-icon></span>
                            <div class="d-none d-sm-block">
                                <h6 class="fw-bold fs-4 mb-1 profile-name" style="max-width:20ch; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                    <%= user?.name?.substring(0, 20) %>
                                </h6>
                                <p class="fs-3 lh-base mb-0 profile-subtext">
                                    <%= user?.rolename %>
                                </p>
                            </div>
                        </div>
                    </a>
                    <div class="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up" aria-labelledby="drop1">
                        <div class="profile-dropdown position-relative" data-simplebar>
                            <div class="pt-3 px-7">
                                <h3 class="mb-0 fs-5">User Profile</h3>
                            </div>

                            <div class="d-flex align-items-center mx-7 py-9 border-bottom">
                                <iconify-icon icon="solar:user-circle-bold-duotone" style="font-size:90px;" class="text-primary"></iconify-icon>
                                <div class="ms-4">
                                    <h4 class="mb-0 fs-5 fw-normal"><%= user?.name %></h4>
                                    <span class="text-muted"><%= user?.rolename %></span>
                                    <p class="text-muted mb-0 mt-1 d-flex align-items-center">
                                        <iconify-icon icon="solar:mailbox-line-duotone" class="fs-4 me-1"></iconify-icon>
                                        <%= user?.email %>
                                    </p>
                                </div>
                            </div>

                            <div class="message-body">
                                <a href="/account" class="dropdown-item px-7 d-flex align-items-center py-6">
      <span class="btn px-3 py-2 bg-info-subtle rounded-1 text-info shadow-none">
        <iconify-icon icon="solar:settings-line-duotone" class="fs-7"></iconify-icon>
      </span>
                                    <div class="w-75 d-inline-block v-middle ps-3 ms-1">
                                        <h5 class="mb-0 mt-1 fs-4 fw-normal">
                                            My Profile
                                        </h5>
                                        <span class="fs-3 d-block mt-1 text-muted">Account Settings</span>
                                    </div>
                                </a>

                                <a href="javascript:void(0)" data-open-cookie-settings class="dropdown-item px-7 d-flex align-items-center py-6">
      <span class="btn px-3 py-2 bg-success-subtle rounded-1 text-success shadow-none">
        <iconify-icon icon="solar:shield-minimalistic-line-duotone" class="fs-7"></iconify-icon>
      </span>
                                    <div class="w-75 d-inline-block v-middle ps-3 ms-1">
                                        <h5 class="mb-0 mt-1 fs-4 fw-normal">Cookie Settings</h5>
                                        <span class="fs-3 d-block mt-1 text-muted">Analytics consent</span>
                                    </div>
                                </a>

                                <!--
                                <a href="javascript:void(0)" class="dropdown-item px-7 d-flex align-items-center py-6">
      <span class="btn px-3 py-2 bg-success-subtle rounded-1 text-success shadow-none">
        <iconify-icon icon="solar:shield-minimalistic-line-duotone" class="fs-7"></iconify-icon>
      </span>
                                    <div class="w-75 d-inline-block v-middle ps-3 ms-1">
                                        <h5 class="mb-0 mt-1 fs-4 fw-normal">My Inbox</h5>
                                        <span class="fs-3 d-block mt-1 text-muted">Messages & Emails</span>
                                    </div>
                                </a>
                                -->
                            </div>

                            <div class="py-6 px-7 mb-1">
                                <a href="/logout"
                                   class="btn btn-primary w-100">Log Out</a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
